import { axios } from './request'

export let orgTerms = {}

export const getTerms = () => {
  return new Promise((resolve) => {
    axios.get('terminology').then((res) => {
      orgTerms = res.data.data
      resolve()
    })
  })
}
